<template>
  <b-modal
    id="import_semiology_form"
    title="IMPORTAR FORMULÁRIO DE SEMIOLOGIA"
    size="lg"
    hide-footer
    @hidden="reset"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="ARQUIVO (.xlsx)" />
          <b-form-file
            :disabled="loading"
            v-model="file"
            placeholder="SELECIONE OU ARRASTE O ARQUIVO PREENCHIDO A PARTIR DO MODELO."
            drop-placeholder="SOLTE O ARQUIVO AQUI..."
            browse-text="PROCURAR"
            accept=".xlsx"
          />
          <small class="text-muted">
            Não tem o modelo em mãos?
            <a href="#" @click.prevent="$emit('download-template')"
              >Baixe o modelo aqui</a
            >.
          </small>
        </b-col>
      </b-row>

      <!-- Erros gerais (arquivo ausente, aba faltando, etc.) -->
      <b-row v-if="errors.length > 0" class="mt-3">
        <b-col>
          <errors-messages :errors="errors" />
        </b-col>
      </b-row>

      <!-- Erros linha a linha, no mesmo padrão usado na importação de residentes -->
      <b-row v-if="results.length > 0" class="mt-3">
        <b-col>
          <v-card>
            <v-card-title> Não foi possível importar </v-card-title>
            <v-card-text>
              <errors-messages
                :errors="[
                  'Corrija as informações abaixo e envie o arquivo novamente. Nenhuma pergunta foi criada.',
                ]"
              />
              <b-row>
                <b-col>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(result, index) in results"
                      :key="index"
                    >
                      <v-expansion-panel-header>
                        {{ result.filename }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <b-row v-if="result.reason">
                          <b-col>
                            <errors-messages :errors="[result.reason]" />
                          </b-col>
                        </b-row>
                        <b-row v-if="result.sheets.length > 0">
                          <b-col>
                            <b-card no-body>
                              <b-tabs card>
                                <b-tab
                                  v-for="(sheet, sheet_index) in result.sheets"
                                  :key="sheet_index"
                                  :title="sheet.name"
                                >
                                  <b-card-text>
                                    <b-row v-if="sheet.reason">
                                      <b-col>
                                        <errors-messages
                                          :errors="[sheet.reason]"
                                        />
                                      </b-col>
                                    </b-row>
                                    <b-row v-if="sheet.rows.length > 0">
                                      <b-col>
                                        <v-data-table
                                          dense
                                          :headers="[
                                            { text: 'Linha', value: 'linha' },
                                            {
                                              text: 'Categoria',
                                              value: 'categoria',
                                            },
                                            {
                                              text: 'Pergunta',
                                              value: 'pergunta',
                                            },
                                            { text: 'Motivo', value: 'reason' },
                                          ]"
                                          :items="
                                            sheet.rows.map((row) => ({
                                              linha: row.body.linha,
                                              categoria: row.body.categoria,
                                              pergunta: row.body.pergunta,
                                              reason: row.reason,
                                            }))
                                          "
                                        />
                                      </b-col>
                                    </b-row>
                                  </b-card-text>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </b-col>
                        </b-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </b-col>
              </b-row>
            </v-card-text>
          </v-card>
        </b-col>
      </b-row>

      <b-row align-h="end" class="mt-3">
        <b-col cols="auto">
          <v-btn
            :disabled="loading"
            :loading="loading"
            class="btn-save"
            type="submit"
          >
            <i class="fas fa-file-upload mr-2 text-twenty" /> IMPORTAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";

export default {
  name: "ImportForm",

  components: {
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      file: null,
      loading: false,
      errors: [],
      results: [],
    };
  },

  methods: {
    reset() {
      this.file = null;
      this.loading = false;
      this.errors = [];
      this.results = [];
    },

    async evOnSubmit() {
      try {
        this.errors = [];
        this.results = [];

        if (!this.file) {
          this.errors = ["Selecione o arquivo preenchido para continuar"];
          return;
        }

        this.loading = true;

        let formData = new FormData();
        formData.append("file", this.file);

        let response = await api.post(
          "/rest-home/semiology/import/execute",
          formData
        );

        let { error, errors, message, results, semiology_form_id } =
          response.data;

        if (error) {
          this.errors = errors || [];
          this.results = results || [];
        } else {
          toast(message, "success");
          this.$emit("imported", semiology_form_id);
          this.$bvModal.hide("import_semiology_form");
        }
      } catch (error) {
        console.log(error);
        this.errors = [
          "Ocorreu um erro ao importar o formulário. Tente novamente.",
        ];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>